import { Grid, Switch, Typography } from "@material-ui/core";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { check } from "../../RBAC/AccessControl";
import rules from "../../../rbac-rules";
import { useSelector } from "react-redux";
import permissions from "../../../permissions";

{/** Save and update Google search */}

function GoogleEnabled(props) {
    console.log("props value:: ",props)
    const { brand, updateBrand, saveBrand } = props;
    const [googleEnabled, setGoogleEnabled] = useState(brand.googleEnabled);
    const { role } = useSelector(state => state.users.currentUser);
    const handleGoogleEnabledChange = (event) => {
        setGoogleEnabled(event.target.checked)
        const updatedBrand = { ...brand, googleEnabled: event.target.checked };
        saveBrand({ brand: updatedBrand, msg: 'Google enabled updated!' });
        updateBrand(updatedBrand);
    };
    return (
        <>
            <Typography className={props.classes.title} gutterBottom variant='body2'>
                Enable Google
            </Typography>
            <Grid component="label" container alignItems="center">
                <Grid item>Off</Grid>
                <Grid item>
                    <Switch
                        id="googleEnabled"
                        checked={googleEnabled}
                        onChange={event => handleGoogleEnabledChange(event)}
                        name="googleEnabled"
                        disabled={!check(rules, role, [permissions.brands.update.basic,])}
                    />
                </Grid>
                <Grid item>On</Grid>
            </Grid>
        </>
    )
}

GoogleEnabled.propTypes = {
    classes: PropTypes.object,
    brand: PropTypes.object,
    updateBrand: PropTypes.func,
    saveBrand: PropTypes.func
};

export default GoogleEnabled;
